/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { FiraSansBold, FontWeight } from 'components/Text/Text';
import { Breakpoints } from 'constants/Breakpoints';
import Colors from "constants/Colors";
import { Label as FormLabel } from '@fitinsur/components';

export const Content = styled.div`
  margin-top: 25px;
  margin-left: 13px;
  padding-bottom: 50px;
`

export const TitleBar = styled.div`
  background-color: ${Colors.PRIMARY1};
  border: 1px solid ${Colors.PRIMARY1};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-bottom: 0;
  
  display: flex;
  justify-content: space-between;
`

export const TitleInfo = styled.h3`
  color: #FFF;
  font-size: 20px;
  margin: 12px;
  margin-left: 15px;
`

export const TitleAlter = styled.h3`
  color: #FDC830;
  font-weight: 700;
  font-size: 20px;
  margin-right: 15px;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 15px;
  height: 50px;
  line-height: 50px;
`

export const Option = styled.div`
  // background-color: ${(props) => props.isSelected ? 'white' : '#E5E5E5'};
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-transform: uppercase;
  padding: 10px;
  cursor: pointer;
  color: white;

  i::before {
    background-size: 16px 17px;
    width: 16px;
    height: 17px;
  }
`

export const SmallTitle = styled.h3`
  line-height: 20px;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 0px;
`

export const BrokerContainer = styled.div`
  margin-top: 30px;
  border-top: 1px solid #ECECEC;

  p {
    font-weight: 700;
  }

`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;


const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  justify-content:space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 15px;
    width: 100%;
  }
`;

 export const IconButton = styled.button`
  display: flex;
  width: 50px;
  height: 50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 20px;
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 60px;
  right: 24px;

  position: absolute;
`;

export const CoverageContainer = styled.div`
  display: flex;
  flex-flow: wrap;
`

export const CoverageList = styled.div`
  width: 33%;
  margin-top: 56px;
`

export const CoverageItemList = styled.div`
  height: 57px;
  display: flex;
  align-items: center
`

export const CoverageLine = styled.div`
  position: relative;

  div {
    border-bottom: 1px solid #E2E2E2;
    position: absolute;
    width: 290%;
    bottom: 0px
  }
`

export const AddButton = styled.div`
  color: white;
  font-size: 22px;
  text-align: center;
  width:25px;
  height:25px;
  border: 0px;
  border-radius: 25px;
  background-color: #53565a;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: auto;
`;

export const RefreshButon = styled.button`
  display: flex;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: flex-end;
  margin: 0px;
  padding: 0;
  margin-bottom: 5px;
  margin-right: 3px;
`;

export const TagInput = styled.input`
  flex: 1;
  display:none;
  border: none;
  width:100%;
  
  &:focus {
      outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: .75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 44px;
  width: auto;
  white-space: nowrap;
  font-family: 'Quicksand';
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  -webkit-transition: background-color 0.15s ease,color 0.15s ease,width 0.3s ease,border 0.5s ease,border-color 0.5s ease,box-shadow 0.15s ease;
  transition: background-color 0.15s ease,color 0.15s ease,width 0.3s ease,border 0.5s ease,border-color 0.5s ease,box-shadow 0.15s ease;
  text-align: center;
  color: #FFFFFF;
  background-color: #5c078c;
  box-shadow: 0px 8px 24px rgba(0,0,0,0.1);
  ${FiraSansBold}
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  justify-content: start;
  padding-top: 10px;

  & > div {
    margin-right: 40px;
  }

  i {
    margin-left: 0px;
  }
  
  @media (max-width: ${Breakpoints.sm}) {
    justify-content: space-around;
    padding-bottom: 15px;


    & > div {
      margin-right: 0px;
    }
  }
`

export const Label = styled(FormLabel)`
  color: ${Colors.GRAY[0]};
  font-weight: ${FontWeight.Bold};
  font-size: 14px;
`;

export const Plan = styled.div`
  ${({ hide }) => !hide ? '' : 'display: none'}
  > div {
    > div:nth-child(3), > div:nth-child(5) {

      > div:nth-child(3) {
        min-height: 0px;
        margin-bottom: 0px;
      }

      > div:nth-child(2) {
        flex-direction: row;
        i {
          margin-left: 0px
        }
        span {
          margin-right: 25px;
        }
      }
    }
    > div {
      > div {
        > div:nth-child(3) {
          min-height: 0px;
          margin-bottom: 0px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    > div {
      > div:nth-child(3), > div:nth-child(5) {
        > div:nth-child(2) {
          justify-content: space-between;
        }
      }
    }
  }

`


export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.PINK};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.PURPLE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const ContentAlert = styled.div`
  width: 100%;  
  margin-top: 20px;
  p{
    color: ${Colors.GRAY[1]};
    margin-bottom: 30px;
    margin-top: 0px;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const Textarea = styled.textarea`
    width: 100%;
    height: 100px;
    border: 1px solid #888;
    border-radius: 4px;
    margin-top: 0px;
    padding: 14px;
    margin-bottom: 10px;
`;

export const ContentTextarea = styled.div`
  width: 100%;  
  margin-top: 0px;
  margin-bottom: 0px;
  p{
    color: ${Colors.GRAY[0]};
    margin-bottom: 5px;
    margin-top: 10px;
    font-weight: 800;
    font-size: 14px;
  }
`;

export const TextConfirmation = styled.p`
  padding: 0 10px;
  margin-bottom: 30px;
`

export const TextQuestion = styled.p`
  padding: 0 10px;
  margin: 10px 0;
`

export const ClausesContainer = styled.div`
  margin: 10px;
  border: 1px solid ${Colors.GRAY[3]};
  padding: 10px;
`;

export const ClauseContent = styled.div`
  display: flex;
  align-items: center;
  color: ${Colors.GRAY[6]};
  font-weight: 700;
  font-size: 13px;
  text-align: left;
  min-height: 30px;
  padding-left: 10px;
`;

export const PartnerSignatureLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const QualificationContainer = styled.div`
  display: flex;
  align-items: center;
  width: 20%;
  margin-right: 20px;
`;

export { ButtonContent, ButtonContainer }